// Utility functions for URL handling

// Get base URL for file uploads
export const getBaseURL = () => {
  const apiUrl = import.meta.env.VITE_API_URL || "http://localhost:8080/api";
  // Remove /api from the end to get the base server URL
  return apiUrl.replace("/api", "");
};

// Helper function to construct full logo URL
export const getFullLogoUrl = (logoPath) => {
  if (!logoPath) return null;

  // If it's already a full URL, return as is
  if (logoPath.startsWith("http")) {
    return logoPath;
  }

  // Construct full URL
  const baseURL = getBaseURL();
  const fullUrl = `${baseURL}${logoPath}`;

  // Debug logging
  console.log("Logo URL construction:", {
    originalPath: logoPath,
    baseURL: baseURL,
    fullUrl: fullUrl,
  });

  return fullUrl;
};

// Helper function to construct full file URL for any upload type
export const getFullFileUrl = (filePath, uploadType = "company-logos") => {
  if (!filePath) return null;

  // If it's already a full URL, return as is
  if (filePath.startsWith("http")) {
    return filePath;
  }

  // Construct full URL
  const baseURL = getBaseURL();
  return `${baseURL}/uploads/${uploadType}/${filePath}`;
};

// Helper function to get relative path from full URL
export const getRelativePath = (fullUrl) => {
  if (!fullUrl) return null;

  // If it's already a relative path, return as is
  if (!fullUrl.startsWith("http")) {
    return fullUrl;
  }

  // Extract relative path from full URL
  const baseURL = getBaseURL();
  return fullUrl.replace(`${baseURL}/uploads/`, "");
};
